import { Tag } from "./tag";
import { ColorDictionary, OptionDictionary } from "./types";

const default_options = {
        "Legend": false,
        "Orthogonal": true,
        "Fields": false,
        "Structural": true,
        "Namespaces": true,
        "Standalones": true,
    } as OptionDictionary

export interface Assembly {
    name: string,
    diagramHash: string | null,
    is_cached: boolean, //Edit261008 add svg caching
    version?: number,
    projects: string[],  //include or exclude projects, based on name. Allows tags to be shared across projects without neccisarily being shared across assemblies, as the assembly can exclude projects
    include_untagged_comps: boolean,
    include_untagged_ships: boolean,
    tags: Tag[],  //included or excluded tags
    options: OptionDictionary,
    colors: ColorDictionary,
}

export const newAssemblyObject: Assembly = {
  name: "",
  diagramHash: null,
  is_cached: false, //Edit261008 add svg caching
    projects: [],
    include_untagged_comps: true,
    include_untagged_ships: true,
    tags: [],
    options: { ...default_options } as OptionDictionary,
    colors: {} as ColorDictionary,
}
